import { required, email } from "vee-validate/dist/rules";
import { extend } from "vee-validate";

extend("required", {
    ...required,
    message: "This field is required"
});

extend('required-check', {
    validate(value) {
        return value === true;
    },
    message: 'This field is required',
});

extend("email", {
    ...email,
    message: "Invalid email"
});

extend('positive', value => {
    return value >= 0;
});

extend('odd', value => {
    return value % 2 !== 0;
});

extend('min', {
    validate(value, args) {
        return value.length >= args.length;
    },
    params: ['length']
});

extend('max', {
    validate(value, args) {
        return value.length <= args.length;
    },
    params: ['length']
});

extend('size', {
    validate(value, args) {
        return value.toString().replaceAll(' ', '').replaceAll('-', '').length == parseInt(args.length);
    },
    params: ['length'],
    message: 'Must have {length} characters'
});


extend('code', {
    validate(value, args) {
        if (value) {
            return value.toString().replaceAll(' ', '').length == parseInt(args.length);
        } else {
            return false;
        }
    },
    params: ['length'],
    message: 'Invalid code'
});

extend('requiredcode', {
    validate(value) {
        return value.toString().replaceAll(' ', '').length > 0;
    },
    message: 'code is required'
});